<template>
  <canvas id="canvas">
  </canvas>
</template>

<script>
import bgcanvas from '../../../static/js/bg-canvas'
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.initCanvas();
  },
  methods: {
    // 绘制canvas
    initCanvas() {
      // console.log("绘制canvas")
      window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

      let canvas = document.getElementById('canvas');
      let ctx = canvas.getContext('2d');
      let w = canvas.width = canvas.offsetWidth;
      let h = canvas.height = canvas.offsetHeight;
      let circles = [];
      let current_circle = new bgcanvas.currentCirle(0, 0)

      let draw = function () {
        ctx.clearRect(0, 0, w, h);
        for (let i = 0; i < circles.length; i++) {
          circles[i].move(w, h);
          circles[i].drawCircle(ctx);
          for (let j = i + 1; j < circles.length; j++) {
            circles[i].drawLine(ctx, circles[j])
          }
        }
        if (current_circle.x) {
          current_circle.drawCircle(ctx);
          for (let k = 1; k < circles.length; k++) {
            current_circle.drawLine(ctx, circles[k])
          }
        }
        requestAnimationFrame(draw)
      }

      let init = function (num) {
        for (let i = 0; i < num; i++) {
          circles.push(new bgcanvas.Circle(Math.random() * w, Math.random() * h));
        }
        draw();
      }
      init(150)
      window.onmousemove = function (e) {
        e = e || window.event;
        let addheight = document.body.scrollTop;
        current_circle.x = e.clientX;
        current_circle.y = e.clientY+addheight;
      }
      window.onmouseout = function () {
        current_circle.x = null;
        current_circle.y = null;
      };
    }
  }
}
</script>

<style lang="stylus" scoped>
  #canvas {
    display : block;
    width : 100%;
    top : 0;
    min-height : 2000px;
    height: 100%;
    position : absolute;
  }
</style>





// WEBPACK FOOTER //
// Bgcanvas.vue?3cc255f1